import { NTHFlag } from '../../../../shared/constants/flag';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, ViewChild, SimpleChanges, Output, EventEmitter, OnChanges, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, AbstractControl } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { TvaModel } from 'src/app/shared/models/simple-types/tva.model';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { StateService } from 'src/app/shared/services/state.service';
import * as util from 'src/app/shared/constants/util';
import { BcLineModel } from 'src/app/shared/models/societe-linked/bc/bc-line.model';
import { ArticleModel } from 'src/app/shared/models/societe-linked/article.model';
import { CgChargeModel } from 'src/app/shared/models/simple-types/cg-charge.model';
import { CompModel } from 'src/app/shared/models/societe-linked/comp.model';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { Ca2Model } from 'src/app/shared/models/societe-linked/ca2.model';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import * as moment from 'moment';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { list } from 'postcss';
import { BcComponentsService } from '../../bc-components.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-edit-bc-line-list',
  templateUrl: './edit-bc-line-list.component.html',
  styleUrls: ['./edit-bc-line-list.component.scss']
})
export class EditBcLineListComponent implements OnChanges {
  @ViewChild('table', { static: true }) table;
  @Input() form: UntypedFormGroup;
  @Input() bcLineForm: UntypedFormGroup;
  @Input() societe: SocieteModel;
  @Input() modeRead : boolean;
  bcLine: BcLineModel[] = [];
  society: SocieteModel;
  bcLineFormArray: UntypedFormArray;
  articles: ArticleModel[] = [];
  cgCharges: CgChargeModel[] = [];
  comps: CompModel[] = [];
  ca1s: Ca1Model[] = [];
  ca2s: Ca2Model[] = [];
  nas: NaModel[] = [];
  tvas: TvaModel[] = [];
  showDelay = new UntypedFormControl(0);
  hideDelay = new UntypedFormControl(0);
  public delivrerAll = false;

  ValidationStatus: string[] = ['A Valider', 'Validation 1', 'Validation 2', 'Validation 3' , 'Validation 4'];
  displayedColumnsBC: string[] = ['select', 'annule', 'p', 'd', 'solder', 'libelle', 'mntHt', 'pu', 'qte', 'qteRestant', 'qteLiv', 'htLiv', 'livraisonsBc', 'qteLitige'];
  matDataSourceBCLigne: MatTableDataSource<AbstractControl> = new MatTableDataSource<AbstractControl>();
  selection = new SelectionModel<AbstractControl>(true, []);
  selectionAnnule = new SelectionModel<AbstractControl>(true, []);
  @Output() selected: EventEmitter<SelectionModel<AbstractControl>> = new EventEmitter<SelectionModel<AbstractControl>>();

  
  
  public FlagEnum: NTHFlag;
  public util = util;
  constructor(
    public dialog: MatDialog,
    private state: StateService,
    private bcComponentsService: BcComponentsService,
    private changeDetectorRef: ChangeDetectorRef ) {
    this.state.society.subscribe(result => {
      this.society = result;
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (this.form) {
      this.bcLineFormArray = this.form.get('bcLines') as UntypedFormArray;
      let i = 0;
      this.bcLineFormArray.controls.forEach(line => {
        if (line.get('qteAnnule').value + line.get('qteLivre').value >= line.get('qte').value) {
          i++;
        }
        if(line.get('qteRestant').value !== 0 && line.get('code').value !== "0001") {
          const newQteRestant = line.get('qte').value - line.get('qteLivre').value
          // Si livraison avec tolérence on remet qteRestant à 0 sinon la qteRestant est calculé
          newQteRestant < 0 ? line.get('qteRestant').setValue('0'): line.get('qteRestant').setValue(newQteRestant)
        }
        const livsBc = line.get('livraisonsBc') as UntypedFormArray;
        livsBc.controls.forEach(liv => {
          var oldvalue = liv.get('qteLitige').value;
          liv.get('qteLitige').valueChanges.subscribe(x => {
            if (x > liv.get('qteLivre').value){
              liv.get('qteLitige').setValue(liv.get('qteLivre').value);
            }
            if(!x && oldvalue !== x){
              liv.get('qteLitige').setValue(0);
            }
          });
        });
      });
      if (i === this.bcLineFormArray.controls.length) {
        this.delivrerAll = true;
      } else {
        this.delivrerAll = false;
      }
      this.reload();
    }
  }

  reload(): void {
    if (this.bcLineFormArray) {
      this.matDataSourceBCLigne = new MatTableDataSource<AbstractControl>(this.bcLineFormArray.controls);
    }
  }

  masterToggle(): void {
    if (!this.isAllSelected()){
      this.matDataSourceBCLigne.data.forEach(row => {
        // tslint:disable-next-line: max-line-length
        if (row.get('qteAnnule').value + row.get('qteLivre').value !== row.get('qte').value && !row.get('bAnnule').value && !this.selectionAnnule.isSelected(row)) {
          this.selectRow(row);
        }
      });
    } else {
      this.matDataSourceBCLigne.data.forEach(row => {
        // tslint:disable-next-line: max-line-length
        if (row.get('qteAnnule').value + row.get('qteLivre').value !== row.get('qte').value && !row.get('bAnnule').value && !this.selectionAnnule.isSelected(row)) {
          this.deselectRow(row);
        }
      });
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    // tslint:disable-next-line: max-line-length
    const numRows = this.matDataSourceBCLigne.data.filter(row => row.get('qteAnnule').value + row.get('qteLivre').value !== row.get('qte').value && !row.get('bAnnule').value).length;
    return numSelected === numRows;
  }

  isAnySelected(): boolean {
    return this.selection.selected.length !== 0;
  }

  change(row: AbstractControl): void {
    if (this.selection.isSelected(row)) {
      this.deselectRow(row);
    } else {
      this.selectRow(row);
    }
  }

  selectRow(row): void {
    this.selection.select(row);
    const livsBc = row.get('livraisonsBc') as UntypedFormArray;
    let resteALivrer = row.get('qte').value;
    livsBc.value.forEach(
      liv => { if (liv.id !== undefined) { resteALivrer -= liv.qteLivre; } }
    );
    // on récupère le dernier form et on lui donne la valeur de la qteRestante A LIVRER
    livsBc.at(livsBc.length - 1).get('qteLivre').setValue(resteALivrer);
  }

  deselectRow(row): void {
    this.selection.deselect(row);
    const livsBc = row.get('livraisonsBc') as UntypedFormArray;
    const resteALivrer = 0;
    // on récupère le dernier form et on lui donne la valeur de la qteRestante A LIVRER
    livsBc.at(livsBc.length - 1).get('qteLivre').setValue(resteALivrer);
  }

  changeAnnule(row): void {
    if (this.selectionAnnule.isSelected(row)) {
      this.selectionAnnule.deselect(row);
    } else {
      const dialogRef = this.dialog.open(ModalInfoOkComponent, {
        data: {
          color: 'primary',
          message: 'Confirmez-vous l’annulation de cette ligne non réceptionnée ou du solde provisionné non facturé ?',
        }
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res) {
          this.selectionAnnule.select(row);
        }else {
          this.selectionAnnule.select(row);
          this.changeDetectorRef.detectChanges();
          this.selectionAnnule.deselect(row);
          this.changeDetectorRef.detectChanges();
        }
        this.selected.emit(this.selectionAnnule);
      });
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: BcLineModel): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
  }

  getMinDate(dateCtrl: UntypedFormGroup): string {
    const ctrl = dateCtrl.getRawValue();
    if (ctrl.id === undefined) {
      const d = moment(); // == moment(new Date(Date.now()))
      if (d.day() === 2 || d.day() === 1) {
        return d.add(-4, 'days').format('YYYY-MM-DD');
      } else {
        return d.add(-2, 'days').format('YYYY-MM-DD');
      }
    } else {
      return moment(ctrl.dLivraison).format('YYYY-MM-DD');
    }
  }

  getMaxDate(): string {
    return moment().format('YYYY-MM-DD');
  }

  isLDisabled(row: UntypedFormGroup): boolean {
    return this.selectionAnnule.isSelected(row);
  }

  isADisabled(row: UntypedFormGroup): boolean {
    return this.selection.isSelected(row);
  }

  onClickSolder(event: Event, element): void {
    event.preventDefault();
    const max = element.get('qte').value - element.get('qteLivre').value;
    const livsBc = element.get('livraisonsBc') as UntypedFormArray;
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        message: 'Voulez-vous solder le restant ?',
        color: 'primary'
      }
    }); 
    dialogRef.afterClosed().subscribe(res => {
      if (res != null) {
        // ne pas annulé dans le cas de ligne soldé
        //element.get('qteAnnule').setValue((element.get('qte').value - element.get('qteLivre').value) - livsBc.at(livsBc.length - 1).get('qteLivre').value);
        element.get('qteRestant').setValue(0);
        element.get('fLivre').setValue(2);
      }else {
        element.get('qteAnnule').setValue(0);
      }
    });
  }
}
